import React, { Dispatch, SetStateAction } from 'react';
import { CalendarChallenge } from 'src/types/shared/Challenge';
import { removeDuplicatesFromArray } from '../../utils/generic';
import SidebarAdminRow from './SidebarAdminRow';

const CalendarSidebarItem: React.FC<CalendarSidebarItemProps> = ({
    challenge,
    isExpanded = false,
    setSelectedChallengeID,
    index,
    style = {},
    setTooltipContent,
}) => {
    const {
        id,
        workshopAdminIDs,
        assessorIDs,
        pitchPresentationAdminIDs,
        challengeLeadID,
    } = challenge;
    const filteredIDs = removeDuplicatesFromArray([
        ...workshopAdminIDs,
        ...assessorIDs,
        ...pitchPresentationAdminIDs,
        challengeLeadID,
    ]);

    const sideBarItemStyle = {
        ...style,
        gridRowStart: `challenge-${id}-start`,
        gridRowEnd: `challenge-${id}-end`,
    };

    const buildSubItemStyle = (stage: string) => {
        return {
            ...style,
            gridRowStart: `challenge-${id}-${stage}-start`,
            gridRowEnd: `challenge-${id}-${stage}-end`,
        };
    };

    return (
        <>
            <div className={`challenge ${index % 2 === 0 ? 'even' : ''}`} style={sideBarItemStyle}>
                <span className="title-container">
                    <i
                        className={`icon fal fa-fw fa-${
                            isExpanded ? 'chevron-up' : 'chevron-down'
                        }`}
                        onClick={() => setSelectedChallengeID(isExpanded ? null : id)}
                    />
                    <span
                        className="sidebaritem-title"
                        onClick={() => setSelectedChallengeID(isExpanded ? null : id)}
                    >
                        {challenge.name}
                    </span>
                </span>
                <SidebarAdminRow adminIDs={filteredIDs} setTooltipContent={setTooltipContent} />
            </div>
            {isExpanded && (
                <>
                    <div className="challenge-subitem" style={buildSubItemStyle('workshop')}>
                        <span>Workshop</span>
                        <SidebarAdminRow
                            adminIDs={workshopAdminIDs}
                            isSubItem
                            stage="workshop"
                            setTooltipContent={setTooltipContent}
                        />
                    </div>
                    <div className="challenge-subitem" style={buildSubItemStyle('livechallenge')}>
                        <span>Live Challenge</span>
                        <SidebarAdminRow
                            adminIDs={[challengeLeadID]}
                            isSubItem
                            stage="livechallenge"
                            setTooltipContent={setTooltipContent}
                        />
                    </div>
                    <div className="challenge-subitem" style={buildSubItemStyle('assessment')}>
                        <span>Assessment</span>
                        <SidebarAdminRow
                            adminIDs={assessorIDs}
                            isSubItem
                            stage="assessment"
                            setTooltipContent={setTooltipContent}
                        />
                    </div>
                    <div className="challenge-subitem" style={buildSubItemStyle('pitch')}>
                        <span>Pitch</span>
                        <SidebarAdminRow
                            adminIDs={pitchPresentationAdminIDs}
                            isSubItem
                            stage="pitch"
                            setTooltipContent={setTooltipContent}
                        />
                    </div>
                </>
            )}
        </>
    );
};

interface CalendarSidebarItemProps {
    challenge: CalendarChallenge;
    isExpanded?: boolean;
    setSelectedChallengeID: Dispatch<SetStateAction<number | null>>;
    index: number;
    style?: React.CSSProperties;
    setTooltipContent: Dispatch<SetStateAction<string[]>>;
}

export default CalendarSidebarItem;
